import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { UpdateReacruiterProfilePayloadInterface } from "./dto";
import { recruiterClient } from "config/axios";
import { QueryKeys } from "config/query-keys";

export const updateRecruiterProfile = ({
  id,
  recruiter,
}: UpdateReacruiterProfilePayloadInterface): Promise<{}> => {
  return recruiterClient.httpClient.put(`/info/${id}`, recruiter);
};

export const useUpdateReacruiterProfile = () => {
  const queryClient = useQueryClient();

  return useMutation({
    onSuccess: async (data, __, ___) => {
      await queryClient.invalidateQueries({ queryKey: [QueryKeys.RECRUITER] });
      notification.success({
        message: "Updated",
        description: "Profile has been successfully updated.",
      });
    },

    mutationFn: updateRecruiterProfile,
  });
};
